import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/data';

export default function FAQ() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于蜜桃传媒，你可能想知道的一切</p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group rounded-lg border border-background-200/70 bg-background-50 overflow-hidden">
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                <h3 className="text-sm font-semibold text-foreground-950 pr-4">{faq.question}</h3>
                <div className="w-6 h-6 flex items-center justify-center shrink-0 rounded-full bg-secondary-100 text-secondary-600 group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line text-sm"></i>
                </div>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}